import React from "react"
import { Separator } from "../shadcn/separator"

/**
 * @description 시각적 구분선. 수평/수직 방향 지원
 * @example
 * <TDivider />
 * <TDivider orientation="vertical" />
 */
interface TDividerProps {
	/** 추가 CSS 클래스 */
	className?: string
	/**
	 * 구분선 방향
	 * @default "horizontal"
	 */
	orientation?: "horizontal" | "vertical"
}

export const TDivider = React.memo((props: TDividerProps) => {
	const { className, orientation = "horizontal" } = props
	return <Separator className={className} orientation={orientation} />
})

TDivider.displayName = "TDivider"
